import hos1 from "../../src/assests/images/Tata Cancer Hospital/Picture1.jpg";
import hos2 from "../../src/assests/images/Tata Cancer Hospital/Picture2.jpg";
import hos3 from "../../src/assests/images/Tata Cancer Hospital/Picture3.jpg";
import ej1 from "../../src/assests/images/Commercial/Elite Jewellers/1.jpg";
import ej2 from "../../src/assests/images/Commercial/Elite Jewellers/2.jpg";
import gt1 from "../../src/assests/images/Commercial/GT Tiles @ Kallakurichi/1.jpg";
import gt2 from "../../src/assests/images/Commercial/GT Tiles @ Kallakurichi/2.jpg";
import gt3 from "../../src/assests/images/Commercial/GT Tiles @ Kallakurichi/1_1 - Photo.jpg";
import gt4 from "../../src/assests/images/Commercial/GT Tiles @ Kallakurichi/1_1 - Photo_1 - Photo.jpg";
import bh1 from "../../src/assests/images/Commercial/Interior/Banquet Hall @ Ayyapanthangal/Enscape_2025-07-02-12-18-31.jpg";
import bh2 from "../../src/assests/images/Commercial/Interior/Banquet Hall @ Ayyapanthangal/Enscape_2025-07-02-12-40-11.jpg";
import bh3 from "../../src/assests/images/Commercial/Interior/Banquet Hall @ Ayyapanthangal/Enscape_2025-07-02-12-55-54.jpg";
import ko1 from "../../src/assests/images/Commercial/Karthy office @ Guduvanchery/Enscape_2025-11-13-11-08-45.jpg";
import ko2 from "../../src/assests/images/Commercial/Karthy office @ Guduvanchery/Enscape_2025-11-13-11-09-17.jpg";
import sm1 from "../../src/assests/images/SM Land developes/1_1 - Photo.jpg";
import sm2 from "../../src/assests/images/SM Land developes/1_2 - Photo.jpg";
import sm3 from "../../src/assests/images/SM Land developes/1_3 - Photo.jpg";
import sm4 from "../../src/assests/images/SM Land developes/1_5 - Photo.jpg";
import sm5 from "../../src/assests/images/SM Land developes/8.jpg";
import sm6 from "../../src/assests/images/SM Land developes/viewScene 1.png";
import sm7 from "../../src/assests/images/SM Land developes/viewScene 5.png";
import sm8 from "../../src/assests/images/SM Land developes/viewScene 6.png";
import san1 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/Enscape_2023-09-13-22-25-08 (1).png";
import san2 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/Enscape_2023-09-13-22-25-08 (2).png";
import san3 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/Enscape_2023-09-13-22-25-08 (3).png";
import san4 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/Enscape_2023-09-13-23-10-28 (1).png";
import san5 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/Enscape_2023-09-13-23-10-28 (2).png";
import san6 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/Enscape_2023-09-13-23-10-28 (3).png";
import san7 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/v1.jpg";
import san8 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/v2.jpg";
import san9 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/v3.jpg";
import san10 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/v4.jpg";
import san11 from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/v5.jpg";
import jag1 from "../../src/assests/images/Residential/Interior/Mr Jagan Residence @ Vanagaram/BEDROOM_V1.jpg";
import jag2 from "../../src/assests/images/Residential/Interior/Mr Jagan Residence @ Vanagaram/BEDROOM_V2.jpg";
import jag3 from "../../src/assests/images/Residential/Interior/Mr Jagan Residence @ Vanagaram/KITCHEN_V1.jpg";
import jag4 from "../../src/assests/images/Residential/Interior/Mr Jagan Residence @ Vanagaram/KITCHEN_V2.jpg";
import jag5 from "../../src/assests/images/Residential/Interior/Mr Jagan Residence @ Vanagaram/LIVING_V1.jpg";
import jag6 from "../../src/assests/images/Residential/Interior/Mr Jagan Residence @ Vanagaram/LIVING_V2.jpg";
import jag7 from "../../src/assests/images/Residential/Interior/Mr Jagan Residence @ Vanagaram/POOJA_V1.jpg";
import saj1 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-10-13-29-39.jpg";
import saj2 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-10-13-32-32.jpg";
import saj3 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-11-19-33-29.jpg";
import saj4 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-11-19-46-52.jpg";
import saj5 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-11-19-49-03.jpg";
import saj6 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-11-20-01-08.jpg";
import saj7 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-12-02-04-24.jpg";
import saj8 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-12-02-08-20.jpg";
import saj9 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-12-02-14-25.jpg";
import saj10 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-12-03-12-39.jpg";
import saj11 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-12-03-13-38.jpg";
import saj12 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-18-13-12.jpg";
import saj13 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-18-33-51.jpg";
import saj14 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-20-49-00.jpg";
import saj15 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-21-00-47.jpg";
import saj16 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-21-01-54.jpg";
import saj17 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-21-40-06.jpg";
import saj18 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-21-49-54.jpg";
import saj19 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-20-21-56-17.jpg";
import saj20 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-21-00-48-52.jpg";
import saj21 from "../../src/assests/images/Residential/Interior/Mr Saju Residence @ Coimbatore/Enscape_2025-11-21-00-52-11.jpg";
import ev1 from "../../src/assests/images/Residential/Interior/Evoluxe @ Karayanchavadi/Enscape_2025-10-08-19-49-35.jpg";
import ev2 from "../../src/assests/images/Residential/Interior/Evoluxe @ Karayanchavadi/Enscape_2025-10-08-19-57-22.jpg";
import ev3 from "../../src/assests/images/Residential/Interior/Evoluxe @ Karayanchavadi/Enscape_2025-10-08-20-06-46.jpg";
import ev4 from "../../src/assests/images/Residential/Interior/Evoluxe @ Karayanchavadi/Enscape_2025-10-09-11-18-38.jpg";
import ev5 from "../../src/assests/images/Residential/Interior/Evoluxe @ Karayanchavadi/Enscape_2025-10-09-11-27-20.jpg";
import ev6 from "../../src/assests/images/Residential/Interior/Evoluxe @ Karayanchavadi/Enscape_2025-10-09-11-34-15.jpg";
import kar1 from "../../src/assests/images/Residential/Interior/Karunagaran Residence @ Siruseri Conceptual/Enscape_2025-09-02-17-05-24.jpg";
import kar2 from "../../src/assests/images/Residential/Interior/Karunagaran Residence @ Siruseri Conceptual/Enscape_2025-09-02-17-10-05.jpg";
import kar3 from "../../src/assests/images/Residential/Interior/Karunagaran Residence @ Siruseri Conceptual/Enscape_2025-09-02-17-22-09.jpg";
import kar4 from "../../src/assests/images/Residential/Interior/Karunagaran Residence @ Siruseri Conceptual/Enscape_2025-09-02-17-29-36.jpg";
import kar5 from "../../src/assests/images/Residential/Interior/Karunagaran Residence @ Siruseri Conceptual/Enscape_2025-09-02-17-38-47.jpg";
import kar6 from "../../src/assests/images/Residential/Interior/Karunagaran Residence @ Siruseri Conceptual/Enscape_2025-09-02-17-45-40.jpg";
import kar7 from "../../src/assests/images/Residential/Interior/Karunagaran Residence @ Siruseri Conceptual/Enscape_2025-09-02-17-54-22.jpg";
import am1 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_1 - Photo.jpg";
import am2 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_2 - Photo.jpg";
import am3 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_3 - Photo.jpg";
import am4 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_4 - Photo.jpg";
import am5 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_5 - Photo.jpg";
import am6 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_7 - Photo.jpg";
import am7 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_9 - Photo.jpg";
import am8 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_11 - Photo.jpg";
import am9 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_16 - Photo.jpg";
import am10 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_17 - Photo.jpg";
import am12 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/2.jpg";
import am13 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/4.jpg";
import am14 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/kitchen/1_1 - Photo.jpg";
import am15 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/kitchen/1_2 - Photo.jpg";
import am16 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/kitchen/1_3 - Photo.jpg";
import am11 from "../../src/assests/images/Residential/Interior/Amir Residence @ Chinnasalem/1_8 - Photo.jpg";
import nh1 from "../../src/assests/images/Residential/Architecture/NH Residence @ Jothi Nagar/Enscape_2025-10-23-15-36-13.jpg";
import nh2 from "../../src/assests/images/Residential/Architecture/NH Residence @ Jothi Nagar/Enscape_2025-10-24-12-51-21.jpg";
import bds1 from "../../src/assests/images/Residential/Architecture/BDS Residence @ Chennai/Enscape_2025-10-18-18-53-29.jpg";
import bds2 from "../../src/assests/images/Residential/Architecture/BDS Residence @ Chennai/Enscape_2025-11-22-15-25-13.jpg";
import sds1 from "../../src/assests/images/Residential/Architecture/SDS Residence @ Ayyapanthangal/Enscape_2025-10-14-15-26-57.jpg";
import sds2 from "../../src/assests/images/Residential/Architecture/SDS Residence @ Ayyapanthangal/Enscape_2025-10-14-15-32-14.jpg";
import ka1 from "../../src/assests/images/Residential/Architecture/Karunagaran Residence @ Siruseri - conceptual/1.jpg";
import ka2 from "../../src/assests/images/Residential/Architecture/Karunagaran Residence @ Siruseri - conceptual/2.jpg";
import ka3 from "../../src/assests/images/Residential/Architecture/Karunagaran Residence @ Siruseri - conceptual/3.jpg";
import ka4 from "../../src/assests/images/Residential//Architecture/Karunagaran Residence @ Siruseri - conceptual/4.jpg";
import lok1 from "../../src/assests/images/Residential/Architecture/Lokesh residence @ Moulivakkam/s1.jpg";
import lok2 from "../../src/assests/images/Residential/Architecture/Lokesh residence @ Moulivakkam/s2.jpg";
import gun1 from "../../src/assests/images/Residential/Architecture/Mrs Gunasundari residence @ Moulivakkam/1.jpg";
import gun2 from "../../src/assests/images/Residential/Architecture/Mrs Gunasundari residence @ Moulivakkam/2.jpg";
import gun3 from "../../src/assests/images/Residential/Architecture/Mrs Gunasundari residence @ Moulivakkam/3.jpg";
import gun4 from "../../src/assests/images/Residential/Architecture/Mrs Gunasundari residence @ Moulivakkam/4.jpg";
import gun5 from "../../src/assests/images/Residential/Architecture/Mrs Gunasundari residence @ Moulivakkam/Enscape_2025-05-23-01-19-31.jpg";
import gun6 from "../../src/assests/images/Residential/Architecture/Mrs Gunasundari residence @ Moulivakkam/Enscape_2025-05-23-01-29-06.jpg";
import gun7 from "../../src/assests/images/Residential/Architecture/Mrs Gunasundari residence @ Moulivakkam/Enscape_2025-05-24-01-24-19.jpg";
import ml1 from "../../src/assests/images/Residential/Architecture/INR_25261005_ML RESIDENCE_MANNARKUDI/INR_25261005_P01.jpg";
import ml2 from "../../src/assests/images/Residential/Architecture/INR_25261005_ML RESIDENCE_MANNARKUDI/INR_25261005_P02.jpg";
import ami1 from "../../src/assests/images/Residential/Architecture/Amir Residence @ Chinnasalem/2.jpg";
import ami2 from "../../src/assests/images/Residential/Architecture/Amir Residence @ Chinnasalem/8.jpg";
import tin1 from "../../src/assests/images/Residential/Architecture/Residence @ Tindivanam/op2_1 - Photo.jpg";
import tin2 from "../../src/assests/images/Residential/Architecture/Residence @ Tindivanam/op2_4 - Photo.jpg";
import ur1 from "../../src/assests/images/Residential/Architecture/Residence @ urappakam/1.jpg";
import ur2 from "../../src/assests/images/Residential/Architecture/Residence @ urappakam/2.jpg";
import mans1 from "../../src/assests/images/Residential/Architecture/Mr Manikandan Residence @ SingaperumalKovil/1_1 - Photo.jpg";
import mans2 from "../../src/assests/images/Residential/Architecture/Mr Manikandan Residence @ SingaperumalKovil/1_2 - Photo.jpg";
import ahe1 from "../../src/assests/images/Residential/Architecture/Ahemed Residence @ Elavanasurkottai/R1_1 - Photo.jpg";
import ahe2 from "../../src/assests/images/Residential/Architecture/Ahemed Residence @ Elavanasurkottai/R1_2 - Photo.jpg";
import gop1 from "../../src/assests/images/Residential/Architecture/Mr Gopi Residence @ Tiruverkadu/1_1 - Photo.jpg";
import gop2 from "../../src/assests/images/Residential/Architecture/Mr Gopi Residence @ Tiruverkadu/1_7 - Photo.jpg";
import mant1 from "../../src/assests/images/Residential/Architecture/Mr Manikandan Residence @ Tiruverkadu/2.jpg";
import mant2 from "../../src/assests/images/Residential/Architecture/Mr Manikandan Residence @ Tiruverkadu/3.jpg";
import t1 from "../../src/assests/images/TNAGAR REDEVOLPMENT/001_1 - Photo.jpg";
import t2 from "../../src/assests/images/TNAGAR REDEVOLPMENT/001_2 - Photo.jpg";
import t3 from "../../src/assests/images/TNAGAR REDEVOLPMENT/001_9 - Photo.jpg";
import t4 from "../../src/assests/images/TNAGAR REDEVOLPMENT/004_22 - Photo.jpg";
import t5 from "../../src/assests/images/TNAGAR REDEVOLPMENT/006_44 - Photo.jpg";
import t6 from "../../src/assests/images/TNAGAR REDEVOLPMENT/006_47 - Photo.jpg";
import t7 from "../../src/assests/images/TNAGAR REDEVOLPMENT/007_13 - Photo.jpg";
import k1 from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/2_2 - Photo.jpg";
import k2 from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/2_5 - Photo.jpg";
import k3 from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/2_8 - Photo.jpg";
import k4 from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/2_9 - Photo.jpg";
import k5 from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/4_22 - Photo.jpg";
import k6 from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/4_23 - Photo.jpg";
import k7 from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/5_24 - Photo.jpg";
import r1 from "../../src/assests/images/Renovation/1.jpeg";
import r2 from "../../src/assests/images/Renovation/2.jpeg";
import r3 from "../../src/assests/images/Renovation/3.jpeg";
import r4 from "../../src/assests/images/Renovation/4.jpeg";
import r5 from "../../src/assests/images/Renovation/5.jpeg";
import r6 from "../../src/assests/images/Renovation/6.jpeg";
import r7 from "../../src/assests/images/Renovation/7.jpeg";
import r8 from "../../src/assests/images/Renovation/8.jpeg";
import r9 from "../../src/assests/images/Renovation/9.jpeg";







export const portfolioData = [
  
  {
    category: "Commercial",
    projects: [
      {
        id: "elite-jewellers",
        title: "Elite Jewellers",
        coverImage: ej1,
        images: [ej1, ej2],
      },
      {
        id: "gt-tiles",
        title: "GT Tiles @ Kallakurichi",
        coverImage: gt1,
        images: [gt1, gt2, gt3, gt4],
      },
      {
        id: "banquet-hall",
        title: "Banquet Hall @ Ayyapanthangal",
        coverImage: bh1,    
        images: [bh1, bh2, bh3],
      },
      {
        id: "karthy-office",
        title: "Karthy office @ Guduvanchery",
        coverImage: ko1,
        images: [ko1, ko2],
      },
      

    ],
  },
  {
    category: "Residential Interior",
    projects: [
        {
        id: "sm-land-developers",
        title: "SM Land Developers",
        coverImage: sm1,
        images: [sm1, sm2, sm3, sm4, sm5, sm6, sm7, sm8],
      },
      {
        id: "santhanam-residence",
        title: "Santhanam Residence @ Maduravoyal",
        coverImage: san1,
        images: [san1, san2, san3, san4, san5, san6, san7, san8, san9, san10, san11],
      },
      {
        id: "jagan-residence",
        title: "Mr Jagan Residence @ Vanagaram",
        coverImage: jag1,
        images: [jag1, jag2, jag3, jag4, jag5, jag6, jag7],
      },
      {
        id: "saju-residence",
        title: "Mr Saju Residence @ Coimbatore",
        coverImage: saj1,   
        images: [saj1, saj2, saj3, saj4, saj5, saj6, saj7, saj8, saj9, saj10, saj11, saj12, saj13, saj14, saj15, saj16, saj17, saj18, saj19, saj20, saj21],
      },
      {
        id: "evoluxe",
        title: "Evoluxe @ Karayanchavadi",
        coverImage: ev1,
        images: [ev1, ev2, ev3, ev4, ev5, ev6],
      },
      {
        id: "karunagaran-residence",
        title: "Karunagaran Residence @ Siruseri Conceptual",
        coverImage: kar1,
        images: [kar1, kar2, kar3, kar4, kar5, kar6, kar7],
      },
      {
        id: "amir-residence",
        title: "Amir Residence @ Chinnasalem",
        coverImage: am1,
        images: [am1, am2, am3, am4, am5, am6, am7, am8, am9, am10, am11, am12, am13, am14, am15, am16],
      }
    ],
  },
  {
    category: "Residential Architecture",
    projects: [
      {
        id: "nh-residence",
        title: "NH Residence @ Elavanasurkottai",
        coverImage: nh1,
        images: [nh1, nh2],
      },
      {
        id: "bds-residence",
        title: "BDS Residence @ Chennai",
        coverImage: bds1,
        images: [bds1, bds2],
      },
      {
        id: "sds-residence",
        title: "SDS Residence @ Ayyapanthangal",
        coverImage: sds1,
        images: [sds1, sds2],
      },
      {
        id: "karunagaran-residence-arch",
        title: "Karunagaran Residence @ Siruseri - conceptual",
        coverImage: ka1,
        images: [ka1, ka2, ka3, ka4],
      },
      {
        id: "lokesh-residence",
        title: "Lokesh residence @ Moulivakkam",
        coverImage: lok1,
        images: [lok1, lok2],
      },
      {
        id: "gunasundari-residence",
        title: "Mrs Gunasundari residence @ Moulivakkam",
        coverImage: gun1,
        images: [gun1, gun2, gun3, gun4, gun5, gun6, gun7],
      },
      {
        id: "ml-residence",
        title: "ML Residence @ Mannarkudi",
        coverImage: ml1,
        images: [ml1, ml2],
      },
      {
        id: "amir-residence-arch",
        title: "Amir Residence @ Chinnasalem",
        coverImage: ami1,
        images: [ami1, ami2],
      },
      {
        id: "tindivanam-residence",
        title: "Residence @ Tindivanam",
        coverImage: tin1,
        images: [tin1, tin2],
      },
      {
        id: "urappakam-residence",
        title: "Residence @ urappakam",
        coverImage: ur1,
        images: [ur1, ur2],
      },
      {
        id: "manikandan-singaperumal",
        title: "Mr Manikandan Residence @ SingaperumalKovil",
        coverImage: mans1,
        images: [mans1, mans2],
      },
      {
        id: "ahemed-elavanasurkottai",
        title: "Mr Ahemed Residence @ Elavanasurkottai",
        coverImage: ahe1,
        images: [ahe1, ahe2],
      },
      {
        id: "gopi-tiruverkadu",
        title: "Mr Gopi Residence @ Tiruverkadu",
        coverImage: gop1,
        images: [gop1, gop2],
      },
      {
        id: "manikandan-tiruverkadu",
        title: "Mr Manikandan Residence @ Tiruverkadu",
        coverImage: mant1,
        images: [mant1, mant2],
      }
     
    ],
  },
  {
    category: "Hospital",
    projects: [
      {
        id: "hospital-1",
        title: "Tata Cancer Hospital",
        coverImage: hos1,
        images: [hos1, hos2, hos3],
      },
    ],
  },
  {
    category: "Landscape Design",
    projects: [
        {
            id: "tnagar-redevelopment",
            title: "TNagar Redevelopment",
            coverImage: t2,
            images: [t1, t2, t3, t4, t5, t6, t7],
        },
        {
            id: "kotturpuram-park-redevelopment",
            title: "Kotturpuram Park Redevelopment",
            coverImage: k1,
            images: [k1, k2, k3, k4, k5, k6, k7],
        }

    ]  
},
{
    category: "Renovation",
    projects: [
        {
            id: "renovation cbe",
            title: "Renovation @ Coimbatore",
            coverImage: r1,
            images: [r1, r2, r3, r4, r5, r6, r7, r8, r9],
        },
    ]
        
}

];
